import React from "react";

function SpecialMeal(props) {
  return (
    <div
      className=" mx-2 w-auto delay-0 hover:shadow-2xl hover:-translate-y-4 transition cursor-pointer h-[15.9rem]  xl:h-[20rem] relative "
      key={props.id}
      onClick={props.handleShow}
    >
      <div className="w-full absolute bottom-[0rem]">
        <div className=" w-[100%]  mx-auto h-[5rem] bottom-3 bg-white  pt-2 pl-3 pb-3 ">
          <h1 className=" text-xl capitalize  xl:text-2xl text-[#707070] font-Abhaya">
            {props.data.name}
          </h1>
          <h1 className="text-xs xl:text-[0.9rem] font-poppins font-extrabold text-[#707070]">
            {props.data.description}
          </h1>
        </div>
      </div>
      <img
        src={props.data.image}
        className="w-full object-cover h-full rounded-xl"
        alt=""
      />
    </div>
  );
}

export default SpecialMeal;
